import styled from 'styled-components';

// Wrapper full-width — vive dentro de uma s.Section com SectionTag em
// cima, mesma estrutura visual do Resumo/Detalhe operacional na tela
// /dashboard/customer/plant. Padding ajustado pra dar respiro nas
// bordas sem o chart encostar.
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 14px 20px 12px;
  gap: 8px;
  box-sizing: border-box;
`;

// Header: titulo + sumario (total da janela). Layout horizontal pra
// economizar altura vertical — o card ja vai ter 200px+ pra o chart.
export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.darkerblue};
  letter-spacing: 0.2px;
`;

export const SubTitle = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.label};
  margin-left: 6px;
`;

// Total agregado da janela (soma dos 7 dias) — KPI rapido pro operador
// ver "quanto gerou na semana" sem fazer conta mental.
export const Total = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-variant-numeric: tabular-nums;
`;

export const TotalValue = styled.span`
  font-size: 18px;
  font-weight: 800;
  color: ${(props) => props.color || props.theme.colors.green};
`;

export const TotalUnit = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
`;

export const TotalLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.7;
  margin-right: 4px;
  align-self: center;
`;

// Container do BarChart. Altura fixa generosa (160px) — equilibra entre
// dar leitura clara das barras e nao consumir muito da viewport ja
// dividida entre 3 secoes na coluna esquerda.
export const ChartArea = styled.div`
  width: 100%;
  height: 160px;
  position: relative;
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 160px;
  color: ${(props) => props.theme.colors.label};
  font-size: 12px;
  font-style: italic;
  opacity: 0.7;
`;
